export default __webpack_public_path__ + "static/media/warning--traffic-merges-left-buses--g1.bafa36cd.png";